// Push directo, sin dataLayerPushDeferred: si falla la carga sin recargar, se navega justo después.
const pushInteraction = (eventType, eventDetail) => {
    window.dataLayer.push({
        event: 'clic_element',
        event_type: eventType,
        event_detail: eventDetail,
    });
};

const pushFilter = (name, value) => {
    pushInteraction('club-christmas-filter', `${name}:${value || 'todas'}`);
};

const listenToFilterForm = (form) => {
    let measuredValues = new FormData(form);

    // En escritorio el formulario se envía solo al cambiar una opción (requestSubmit), así que pasa también por aquí.
    form.addEventListener('submit', () => {
        const values = new FormData(form);

        ['categoria', 'precio', 'orden'].forEach((name) => {
            if (values.get(name) !== measuredValues.get(name)) {
                pushFilter(name, values.get(name));
            }
        });

        measuredValues = values;
    });

    // Tras un chip o atrás/adelante, lo que hay que comparar es lo que muestra ahora el panel.
    document.addEventListener('club-christmas:results-updated', () => {
        measuredValues = new FormData(form);
    });
};

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('club-christmas-filter-form');

    if (form) {
        listenToFilterForm(form);
    }
});

document.addEventListener('club-christmas:load-more', (e) => {
    pushInteraction('club-christmas-load-more', `${e.detail.mode}:${e.detail.page}`);
});

// Delegado en document: tarjetas y chips se sustituyen sin recargar la página.
document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) {
        return;
    }

    const cardLink = e.target.closest('[data-club-christmas-grid] a[data-variant-code]');
    const categoryChip = e.target.closest('[data-club-christmas-category]');

    if (cardLink) {
        pushInteraction('club-christmas-product', cardLink.dataset.variantCode);
    }

    if (categoryChip) {
        pushFilter('categoria', categoryChip.dataset.clubChristmasCategory);
    }

    if (e.target.closest('.club-christmas-coupon__copy')) {
        pushInteraction('club-christmas-copy-coupon', 'NAVIDADCLUB');
    }
});
